import request from '@/utils/request'

//设备列表
export const devicePage = (data = {}) => request({ url: `/api/estate/v1/device/devicePage`, method: 'post', data })

export const deviceCount = (data = {}) => request({ url: `/api/estate/v1/device/deviceCount`, method: 'post', data })

export const deviceDetail = (data = {}) => request({ url: `/api/estate/v1/device/deviceDetail`, method: 'post', data })

export const deviceIns = (data = {}) => request({ url: `/api/estate/v1/device/deviceIns`, method: 'post', data })

export const deviceUpd = (data = {}) => request({ url: `/api/estate/v1/device/deviceUpd`, method: 'post', data })

export const deviceDel = (data = {}) => request({ url: `/api/estate/v1/device/deviceDel`, method: 'post', data })

export const deviceDelBatch = (data = {}) => request({ url: `/api/estate/v1/device/deviceDelBatch`, method: 'post', data })

export const deviceResetQrCode = (data = {}) => request({ url: `/api/estate/v1/device/deviceResetQrCode`, method: 'post', data })

export const deviceBatchDownloadQrCode = (params = {}) =>
  request({ url: `/api/estate/v1/device/deviceBatchDownloadQrCode`, method: 'get', params, responseType: 'blob', timeout: 70_000 })

export const deviceMaintenanceRecordPage = (data = {}) => request({ url: `/api/estate/v1/device/deviceMaintenanceRecordPage`, method: 'post', data })

export const deviceMaintenanceRecordCount = (data = {}) => request({ url: `/api/estate/v1/device/deviceMaintenanceRecordCount`, method: 'post', data })

export const deviceMaintenanceRecordIns = (data = {}) => request({ url: `/api/estate/v1/device/deviceMaintenanceRecordIns`, method: 'post', data })

export const deviceDamageRecordPage = (data = {}) => request({ url: `/api/estate/v1/device/deviceDamageRecordPage`, method: 'post', data })

export const deviceDamageRecordCount = (data = {}) => request({ url: `/api/estate/v1/device/deviceDamageRecordCount`, method: 'post', data })

export const deviceDamageRecordIns = (data = {}) => request({ url: `/api/estate/v1/device/deviceDamageRecordIns`, method: 'post', data })

export const deviceRepairRecordPage = (data = {}) => request({ url: `/api/estate/v1/device/deviceRepairRecordPage`, method: 'post', data })

export const deviceRepairRecordCount = (data = {}) => request({ url: `/api/estate/v1/device/deviceRepairRecordCount`, method: 'post', data })

export const maintenanceRouteDetailsById = (data = {}) => request({ url: `/api/estate/v1/device/maintenanceRouteDetailsById`, method: 'post', data })

export const maintenanceRecordAndItemDetail = (data = {}) => request({ url: `/api/estate/v1/device/maintenanceRecordAndItemDetail`, method: 'post', data })

export const checkRepair = (data = {}) => request({ url: `/api/estate/v1/device/checkRepair`, method: 'post', data })

// 巡检项目管理设备
export const deviceInspectionRouteDeviceList = (data = {}) => request({ url: `/api/estate/v1/device/deviceInspectionRouteDeviceList`, method: 'post', data })

export const deviceLookQrCode = (params = {}) => request({ url: `/api/estate/v1/device/deviceLookQrCode`, method: 'get', params, responseType: 'blob' })

export const deviceInspectionRouteUpd = (data = {}) => request({ url: `/api/estate/v1/device/deviceInspectionRouteUpd`, method: 'post', data })

// 巡检项目
export const deviceInspectionPage = (data = {}) => request({ url: `/api/estate/v1/device/deviceInspectionPage`, method: 'post', data })

export const deviceInspectionCount = (data = {}) => request({ url: `/api/estate/v1/device/deviceInspectionCount`, method: 'post', data })

export const deviceInspectionDetail = (data = {}) => request({ url: `/api/estate/v1/device/deviceInspectionDetail`, method: 'post', data })

export const deviceInspectionIns = (data = {}) => request({ url: `/api/estate/v1/device/deviceInspectionIns`, method: 'post', data })

export const deviceInspectionUpd = (data = {}) => request({ url: `/api/estate/v1/device/deviceInspectionUpd`, method: 'post', data })

export const deviceInspectionDel = (data = {}) => request({ url: `/api/estate/v1/device/deviceInspectionDel`, method: 'post', data })

export const deviceInspectionDelBatch = (data = {}) => request({ url: `/api/estate/v1/device/deviceInspectionDelBatch`, method: 'post', data })

export const deviceInspectionRouteDel = (data = {}) => request({ url: `/api/estate/v1/device/deviceInspectionRouteDel`, method: 'post', data })

export const deviceInspectionRouteDelBatch = (data = {}) => request({ url: `/api/estate/v1/device/deviceInspectionRouteDelBatch`, method: 'post', data })

export const deviceInspectionRouteIns = (data = {}) => request({ url: `/api/estate/v1/device/deviceInspectionRouteIns`, method: 'post', data })

export const unassociatedDevice = (data = {}) => request({ url: `/api/estate/v1/device/unassociatedDevice`, method: 'post', data })

// 设备分类
export const deviceCategoryList = (data = {}) => request({ url: `/api/estate/v1/device/deviceCategoryList`, method: 'post', data })

export const deviceCategoryCount = (data = {}) => request({ url: `/api/estate/v1/device/deviceCategoryCount`, method: 'post', data })

export const deviceCategoryDetail = (data = {}) => request({ url: `/api/estate/v1/device/deviceCategoryDetail`, method: 'post', data })

export const deviceCategoryIns = (data = {}) => request({ url: `/api/estate/v1/device/deviceCategoryIns`, method: 'post', data })

export const deviceCategoryUpd = (data = {}) => request({ url: `/api/estate/v1/device/deviceCategoryUpd`, method: 'post', data })

export const deviceCategoryDel = (data = {}) => request({ url: `/api/estate/v1/device/deviceCategoryDel`, method: 'post', data })

export const deviceCategoryDelBatch = (data = {}) => request({ url: `/api/estate/v1/device/deviceCategoryDelBatch`, method: 'post', data })

export const deviceCategoryInspectionQuestionDelBatch = (data = {}) => request({ url: `/api/estate/v1/device/deviceCategoryInspectionQuestionDelBatch`, method: 'post', data })

// 巡检记录
export const deviceInspectionRecordPage = (data = {}) => request({ url: `/api/estate/v1/device/deviceInspectionRecordPage`, method: 'post', data })

export const deviceInspectionRecordCount = (data = {}) => request({ url: `/api/estate/v1/device/deviceInspectionRecordCount`, method: 'post', data })

export const inspectionRecordAndItemDetail = (data = {}) => request({ url: `/api/estate/v1/device/inspectionRecordAndItemDetail`, method: 'post', data })

// 模板管理
export const deviceQuestionTemplatePage = (data = {}) => request({ url: `/api/estate/v1/device/deviceQuestionTemplatePage`, method: 'post', data })

export const deviceQuestionTemplateCount = (data = {}) => request({ url: `/api/estate/v1/device/deviceQuestionTemplateCount`, method: 'post', data })

export const deviceQuestionTemplateIns = (data = {}) => request({ url: `/api/estate/v1/device/deviceQuestionTemplateIns`, method: 'post', data })

export const deviceQuestionTemplateUpd = (data = {}) => request({ url: `/api/estate/v1/device/deviceQuestionTemplateUpd`, method: 'post', data })

export const deviceQuestionTemplateDel = (data = {}) => request({ url: `/api/estate/v1/device/deviceQuestionTemplateDel`, method: 'post', data })

export const deviceQuestionTemplateDetail = (data = {}) => request({ url: `/api/estate/v1/device/deviceQuestionTemplateDetail`, method: 'post', data })

// 维保计划
export const deviceMaintenancePage = (data = {}) => request({ url: `/api/estate/v1/device/deviceMaintenancePage`, method: 'post', data })

export const deviceMaintenanceCount = (data = {}) => request({ url: `/api/estate/v1/device/deviceMaintenanceCount`, method: 'post', data })

export const deviceMaintenanceIns = (data = {}) => request({ url: `/api/estate/v1/device/deviceMaintenanceIns`, method: 'post', data })

export const deviceMaintenanceUpd = (data = {}) => request({ url: `/api/estate/v1/device/deviceMaintenanceUpd`, method: 'post', data })

export const deviceMaintenanceDel = (data = {}) => request({ url: `/api/estate/v1/device/deviceMaintenanceDel`, method: 'post', data })

export const deviceMaintenanceDetail = (data = {}) => request({ url: `/api/estate/v1/device/deviceMaintenanceDetail`, method: 'post', data })

export const unassociatedMaintenanceDevice = (data = {}) => request({ url: `/api/estate/v1/device/unassociatedMaintenanceDevice`, method: 'post', data })

export const deviceMaintenanceItemIns = (data = {}) => request({ url: `/api/estate/v1/device/deviceMaintenanceItemIns`, method: 'post', data })

export const deviceMaintenanceItemPage = (data = {}) => request({ url: `/api/estate/v1/device/deviceMaintenanceItemPage`, method: 'post', data })

export const deviceMaintenanceItemCount = (data = {}) => request({ url: `/api/estate/v1/device/deviceMaintenanceItemCount`, method: 'post', data })

export const deviceMaintenanceItemDel = (data = {}) => request({ url: `/api/estate/v1/device/deviceMaintenanceItemDel`, method: 'post', data })

export const deviceMaintenanceItemDelBatch = (data = {}) => request({ url: `/api/estate/v1/device/deviceMaintenanceItemDelBatch`, method: 'post', data })

//导入
export const excelBeginImport = (data = {}) => request({ url: `/api/estate/v1/oa/excelBeginImport`, method: 'post', data })

// 已完成
